<template>
  <v-container>
    <div class="base-page">
      <logo-with-title :title="$t('payment.errorPage.title')" />

      <v-row align="center" justify="center" class="mt-5">
        <v-col class="text-center">
          <v-icon size="80" color="error">mdi-alert-circle-outline</v-icon>
          <h2 class="error--text mt-4">
            {{ $t("payment.errorPage.paymentFailed") }}
          </h2>
          <h3 class="text-center mt-3">{{ errorMessage }}</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex justify-center mt-5">
          <v-btn text color="primary" :to="{ name: 'plans-view' }">
            <span class="font-weight-bold text-h3">{{
              $t("payment.errorPage.tryAgain")
            }}</span>
          </v-btn>
          <v-btn text color="primary" :to="{ name: 'purchase-history' }">
            <span class="font-weight-bold text-h3">{{
              $t("payment.errorPage.paymentHistory")
            }}</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <lang-select />
      </v-row>
    </div>
  </v-container>
</template>

<script>
import LogoWithTitle from "@/components/LogoWithTitle";
import LangSelect from "@/components/LangSelect";

export default {
  name: "PaymentErrorPage",
  components: { LogoWithTitle, LangSelect },
  computed: {
    errorMessage() {
      return (
        this.$route.query.message || this.$t("payment.errorPage.genericError")
      );
    },
  },
};
</script>
